import { createSlice } from "@reduxjs/toolkit";

const defaultData = {
  id: 0,
  lineUid: null,
  lineImgUrl: null,
  custCode: null,
  dataUser: {},
  partnerId: null,
};

export const ProfileSlice = createSlice({
  name: "Profile",
  initialState: defaultData,
  reducers: {
    setProfile: (state, action) => {
      for (const [key, value] of Object.entries(action.payload)) {
        // console.log(`${key}: ${value}`);
        // Convert id to Number before storing
        if (key === "id" && value != null) {
          state[key] = Number(value);
        } else {
          state[key] = value;
        }
      }
    },
    resetProfile: () => defaultData,
  },
});

// Action creators are generated for each case reducer function
export const { setProfile, resetProfile } = ProfileSlice.actions;

export default ProfileSlice.reducer;
